import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import type { OrchestratedListingDetails } from '@b-stock/fe-core/bstock-next/queries'
import {
  AnalyticsEntityType,
  AnalyticsSource,
} from '@b-stock/fe-core/bstock-react'
import { Breakpoints } from '@b-stock/fe-core/design-system'

import useStorefrontUrl from '@/app/buy/seller/[sellerSlug]/useStorefrontUrl'
import { ListingTagsV2 } from '@/buyer-portal/components/features/listing/ListingTags'
import LegacyBpLink from '@/buyer-portal/components/LegacyBpLink'
import { useAnalytics } from '@/helpers/telemetry/SegmentAnalytics'
import { getSellerLogo } from '@/helpers/utils'

import { ListingWatchlistCTA } from '../ListingWatchlistCTA'

const Body = styled.div`
  align-items: center;
  display: flex;
  gap: 1rem;

  @media ${Breakpoints.max.small} {
    align-items: flex-start;
  }
`

const Logo = styled(LegacyBpLink)`
  flex: 0 0 auto;
`

const SellerLogoImage = styled.img`
  height: 39px;
`

export const SellerTagsRow = ({
  listing,
}: {
  listing: OrchestratedListingDetails
}) => {
  const { formatMessage } = useIntl()
  const { trackButtonClicked } = useAnalytics()
  const { seller } = listing
  const logoUrl = getSellerLogo(seller.storefront?.documents)
  const storefrontUrl = useStorefrontUrl(seller.storefront)

  const logo = logoUrl ? (
    <SellerLogoImage
      src={logoUrl}
      alt={
        seller.storefront?.name
          ? formatMessage(
              { id: 'Auction.image.sellerLogoAlt' },
              { sellerName: seller.storefront.name }
            )
          : formatMessage({ id: 'Auction.image.sellerLogoAltGeneric' })
      }
    />
  ) : null

  const handleStorefrontLogoClick = () => {
    trackButtonClicked({
      screenName: 'listing_detail_page',
      source: AnalyticsSource.HOME_PORTAL,
      entityType: AnalyticsEntityType.BUYER,
      listing_id: listing.lot._id,
      seller_account_id: listing.accountId,
      storefront_name: seller.storefront?.name,
      seller_display_name: seller.account.displayName || '',
      buttonName: 'storefront_logo',
    })
  }

  return (
    <Body>
      {logoUrl && storefrontUrl ? (
        <Logo href={storefrontUrl} onClick={handleStorefrontLogoClick}>
          {logo}
        </Logo>
      ) : (
        logo
      )}
      <ListingTagsV2 listing={listing} />
      <ListingWatchlistCTA listing={listing} />
    </Body>
  )
}
